<template>
	<div id="app">
		<nav v-show="isShow" class="clearfix">
			<div class="menu-wrap">
				<div class="logo-name" :title="merchantName">{{merchantName}}</div>
				<div class="clientOrder" @click="helpOrder" v-if='isHelp'>
					我在帮
					<div class="customerName">{{orderName}}</div>
					<i class="iconfont icon-downTriangle"></i>
					下单
				</div>
				<ul class="menulist">
					<li>
						<router-link class="menu-name" to="/home" @click.native="flushCom">
							<i>首页</i>
						</router-link>
					</li>
					<li>
						<router-link class="menu-name" to="/hotellist" @click.native="flushCom">
							<i>国内酒店</i>
						</router-link>
					</li>
					<li @click="toHotelGroup">
						<router-link class="menu-name" to="/hotelGroup" @click.native="flushCom">
							<i>团房预订</i>
						</router-link>
					</li>
					<li @click="toOverseas">
						<a class="menu-name">
							<i>海外酒店</i>
						</a>
					</li>
					<li @click="toTraval">
						<a class="menu-name">
							<i>旅游</i>
						</a>
					</li>
					<li>
						<router-link to="login/loginHome" v-if="newData!=1||!userIntro" class="menu-name">
							登录
						</router-link>
					</li>
					
					<li v-if="newData!=1||!userIntro">
						<router-link to="login/register" target='_blank' class="menu-name">
							注册
						</router-link>
					</li>
					<router-link v-show="!isHelp" to="notice" tag="li" :class="{'nav-li':true,'newNotice':isNew}"  @click.native="flushCom">
						<i class="iconfont icon-notice" v-if="newData==1&&userIntro"></i>
					</router-link>
					<li class="avatar nav-li" v-if="newData==1&&userIntro">
						<poplist>
							<i class="iconfont icon-avatar02" slot="fuze"></i>
							<itemlist class="h-center up-arrow">
								<li class="userLoginName" v-if="userIntro">{{userIntro.userLoginName}}</li>
								<router-link to="hotelOrderlist" tag="li">订单管理</router-link>
								<router-link :to="{path:'unpaidBill',query:{id:1}}" tag="li">账单管理</router-link>
								<router-link to="personnelManagement" tag="li" v-show="!isHelp">员工管理</router-link>
								<router-link to="accountSetting" tag="li" v-show="!isHelp">我的账户</router-link>
								<router-link to="favorites" tag="li">我的收藏</router-link>
								<router-link to="cooperationAgreement" tag="li">合作协议</router-link>
								<li @click='logout'>退出</li>
							</itemlist>
						</poplist>
					</li>
				</ul>
			</div>
		</nav>
		<router-view :key="activeDate"></router-view>
		<div class="copyright" v-show="isShow&&userIntro.merchantCode!='M10174071'&&userIntro.merchantCode!='M10181682'" :style="{'background':colorBlack}">
			<p v-if="userIntro.merchantCode=='M10000041'">Copyright© 2016-2019. &nbsp; 深圳春秋国际旅行社有限公司 &nbsp; 版权所有 <a href="https://www.miitbeian.gov.cn" target="_blank">粤ICP备11070406号-3
</a></p>
			<p v-else><a href="http://beian.miit.gov.cn" target="_blank">{{versionNumber}}</a></p>
		</div>
		<modal title="帮客户下单" :showModal="isShowB&&isShow" :showFooter="false"  transition="fadeDown" class="accounts" @close="closeModal">
			<div class="accounts-select-pop clearfix">
				<uInput class="accounts-select-inp" @input="searchDistributor" v-model="searchValue" placeholder="分销商名称"></uInput>
				<!--<input type="text" class="accounts-select-inp" @input="searchDistributor" v-model="searchValue" placeholder="分销商名称">-->
				<div class="accounts-select-history" v-if="!searchStatus">
					<p class="accounts-select-history-keyword">
						<span v-for="(items,idx) in keyWordList" @click="searchKeyword(items)" v-if="idx<isIdx">{{items}}</span>
					</p>
					<div class="accounts-select-list accounts-select-history-child" v-if="distributorList">
						<h3>常用分销商</h3>
						<div class="accounts-select-history-list">
							<p class="clearfix" v-for="(items,idx) in distributorList" v-if="idx<7">
								<span class="accounts-name fl">{{items.distributorName}}</span>
								<span class="accounts-user fl" v-if="items.agencyList">
									<uSelect class="accounts-select" v-model="items.selectValue">
							            <uOption :value="user.agentName" v-for="(user,idx) in items.agencyList" :key="idx" :title="user.agentName">{{user.agentName}}</uOption>
							        </uSelect>
								</span>
								<span class="accounts-btn fl" @click="changeDistributor(items)">确定</span>
							</p>
						</div>
					</div>
				</div>
				<div class="loading-wrap" v-if="searchStatus&&loadingStatus">
					<div class="item item1"></div>
					<div class="item item2"></div>
					<div class="item item3"></div>
					<div class="item item4"></div>
					<div class="item item5"></div>
				</div>
				<div class="accounts-select-list accounts-select-last" v-if="searchStatus&&!loadingStatus"><!--searchStatus&&-->
					<div class="accounts-select-history-list">
						<p class="clearfix" v-for="(items,idx) in searchDistributorList" v-if="idx<7">
							<span class="accounts-name fl">{{items.distributorName}}</span>
							<span class="accounts-user fl" v-if="items.agencyList">
								<uSelect class="accounts-select" v-model="items.selectValue">
						            <uOption :value="user.agentName" v-for="(user,idx) in items.agencyList" :key="idx">{{user.agentName}}</uOption>
						        </uSelect>
							</span>
							<span class="accounts-btn fl" @click="changeDistributor(items)">确定</span>
						</p>
						<h3 v-if="searchDistributorList.length<1" class="no-product-notice">
							<i class="icon-gt"></i>没找到分销商！
							<span>现在就去新增</span>
						</h3>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
export default {
	name: 'app',
	data() {
		return {			
			isShow: true,
			colorBlack: '',
			isPerson: false,
			isOpen:false,
			isRevamp:false,
			isHelp:false,
			isShowB:false,
			userStatus:true,
			searchValue: '',
			searchStatus: false,
			loadingStatus :false,
	        distributorList:[],
	        keyWordList:[],
	        searchValue:'',
	        searchDistributorList:[],
	        ajaxNum:1,
	        requestNum:1,
	        isBusiness:false,
	        isIdx:20,
	        orderName:localStorage.getItem("helpCustom")?JSON.parse(localStorage.getItem("helpCustom")):"",
	        merchantName:'',
	        isNoShow:0,
	        activeDate:0,
	        userIntro:localStorage.getItem("loginCont")?JSON.parse(localStorage.getItem("loginCont")):"",
//	        isNew:this.$store.state['isNew'],
            versionNumber:""   //版本号
		}
	},
	computed: {
		newData() {
			if(localStorage.getItem('changeLogin')) {
				this.$store.state['isLogin'] = 1;
			}			
			return this.$store.state['isLogin'];
		},
		getUserInfo() {
		    return this.$store.state.loginNub;
		},
		isNew() {
			return this.$store.state['isNew'];
		}
	},
	created() {
         
    
        this.getMerchant()

		
		var userIntro = JSON.parse(localStorage.getItem('loginCont'));
		if(userIntro&&userIntro.fcState&&!this.orderName){
			this.isHelp = true;
			this.isShowB = true;
		}else if(userIntro&&userIntro.fcState&&this.orderName){
			this.isHelp = true;
			this.isShowB = false;
		}else{
			this.isHelp = false;
			this.isShowB = false;
		}
		this.$store.dispatch('getMerchant');
		var loginData= this.$store.state;		
		if(loginData) loginData=JSON.parse(JSON.stringify(loginData));
		this.merchantName =loginData.loginData&&loginData.loginData.merchantName;

		if(!this.merchantName) this.getMerchantName();
		window.addEventListener('load', this.handleWinFocus);
		if(this.newData==1&&!this.isHelp){
			this.getHasNewMsg()
		}
	},
	beforeDestroy() {
		window.removeEventListener('load', this.handleWinFocus);
	},
	mounted() {
		if(this.userIntro&&this.userIntro.userLoginName && this.userIntro.userName){
			this.isPerson = true;
		}
		setTimeout(function(){
     		var str = 0;
     		var spanLen = $('.accounts-select-history-keyword span').length;
     		for(var i = 0;i<spanLen;i++){
     			var width =  $('.accounts-select-history-keyword span').eq(i).outerWidth()+10;
     			str += width;
     			if(str >=460){
     				self.isIdx = i;
     			}
     		}
     	},3000);
     	function getParam (name) {
	        var search = window.location.href;
	        var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
	        var matcher = pattern.exec(search);
	        var items = null;
	        if (null != matcher) {
	            try {
	                items = decodeURIComponent(decodeURIComponent(matcher[1]));
	            } catch (e) {
	                try {
	                    items = decodeURIComponent(matcher[1]);
	                } catch (e) {
	                    items = matcher[1];
	                }
	            }
	        }
	        return items;
	    };
	    if(getParam('merchantCode')){
	    	this.userIntro = {};
		    this.userIntro.merchantCode = getParam('merchantCode');
		    this.userIntro.companyCode = getParam('companyCode');
		    this.userIntro.userLoginName = getParam('userName');
		    this.userIntro.password = getParam('passwd');
		    this.userIntro.distributorCode = getParam('distributorCode');
		    this.userIntro.disLoginName = getParam('dul');
		    localStorage.setItem('loginCont',JSON.stringify(this.userIntro));
	    }
	    
	},
	methods: {
		getMerchant() {
			var _this = this;
			this.$ajax.post('/home/getMerchant')
				.then(function(response) {
					let res = response.data
					if(res.result == 1) {
					_this.versionNumber = res.model.icpContent
					document.title = res.model.merchantName;
					}
					// 响应成功回调
				}, function(response) {
					// 响应错误回调
				});
		},
	　  flushCom(){
			var str = JSON.stringify(new Date());
			this.activeDate = str;
			if(this.newData==1&&!this.isHelp){ 
				this.getHasNewMsg();
			}
　　　　},
		getMerchantName() {
			var _this = this;
			this.$ajax.post('/home/getMerchant')
				.then(function(response) {
					let res = response.data
					if(res.result == 1) {
						if(!_this.userIntro){
							_this.userIntro={};
							_this.userIntro.merchantCode=res.model.merchantCode;
							this.versionNumber = res.model.icpContent				
						} 	
						_this.merchantName=res.model.merchantName;
						document.title = res.model.merchantName;
					}
					// 响应成功回调
				}, function(response) {
					// 响应错误回调
			});
		},
		createdFn:function(){
			this.orderName="";
			var userIntro = JSON.parse(localStorage.getItem('loginCont'));
			this.userIntro=userIntro;
		},
		toHotelGroup(){
			if(this.newData==1){
				this.$router.push({
					path: '/hotelGroup'
				});
			}else{
				this.$router.push({
					path: '/login/loginHome'
				});
			}		
		},
		toOverseas(){
			if(this.newData==1){
				var _userIntro;
				if(this.isBusiness=true){
					_userIntro=JSON.parse(localStorage.getItem('businessData'));
					if(!_userIntro){
						_userIntro=JSON.parse(localStorage.getItem('loginCont'));
					} 
				}else{
					_userIntro= this.userIntro;
				}
				if(_userIntro){
					var merchantCode = _userIntro.merchantCode;
					var userName = _userIntro.userLoginName;
					var passWord = _userIntro.password;
					var distributorCodeValue = _userIntro.companyCode;
					var userLoginName = _userIntro.disLoginName;
					var disLogin=_userIntro.disLogin?_userIntro.disLogin:_userIntro.userLoginName;
					var discompanyCode=_userIntro.discompanyCode?_userIntro.discompanyCode:_userIntro.companyCode;
					window.open('http://'+window.location.host+'/GDP/hotel-connector.shtml?merchantCode='+merchantCode+'&companyCode='+distributorCodeValue+'&userName='+userName+'&passwd='+passWord+'&dc='+discompanyCode+'&dul='+disLogin+'&url=overseas-hotel!hotelQuery.shtml','_blank');
				}else{
					this.$router.push({
						path: '/login/loginHome?id=overseas'
					});
				}
			}else{
				this.$router.push({
					path: '/login/loginHome?id=overseas'
				});
			}		
		},
		toTraval(){
			if(this.newData==1){
				var _userIntro;
				if(this.isBusiness=true){
					_userIntro=JSON.parse(localStorage.getItem('businessData'));
					if(!_userIntro) _userIntro=JSON.parse(localStorage.getItem('loginCont'));
				}else{
					_userIntro= this.userIntro;
				}
				if(_userIntro){
					var merchantCode = _userIntro.merchantCode;
					var userName = _userIntro.userLoginName;
					var passWord = _userIntro.password;
					var distributorCodeValue = _userIntro.companyCode;
					var userLoginName = _userIntro.disLoginName;
					window.open('http://'+window.location.host+'/dms-distribution-web/index.shtml?mc='+merchantCode+'&ul='+userName+'&pw='+passWord+'&userLoginName='+userLoginName,'_blank');
				}else{
					this.$router.push({
						path: '/login/loginHome?id=traval'
					});
				}
				
			}else{
				this.$router.push({
					path: '/login/loginHome?id=traval'
				});
			}		
		},
		handleWinFocus() {
			var helpData = JSON.parse(localStorage.getItem('helpCustom'));
			if(helpData){
				this.isHelp = true;
				this.orderName = helpData;
			}
			if(this.userIntro&&this.userIntro.fcState){
				this.isHelp = true;
			}
		},
		helpOrder(){
			this.isShowB = true;
			this.getdistributorHistory();
		},
		closeModal(){
			if(this.orderName){
				this.isShowB = false;
			}
		},
		changedistributorBtn(){
	  	  	this.searchValue="";
	  	  	this.searchStatus=false;
	  	  	this.loadingStatus=false;
			this.getdistributorHistory();
		  },	
	  	  searchKeyword(items){
	  	  	this.searchValue=items;
	  	  	this.ajaxNum++;
	  	  	this.searchStatus = true;
	  	  	this.loadingStatus = true;
	  	  	this.getdistributorlist();
	  	  },	
	  	  searchDistributor(){		 
	  	  	 if(this.searchValue==""){
	  	  	 	this.searchStatus=false;
	  	  	 }else{	 	
	  	  	 	var inpValue=this.searchValue;
	  	  	 	let _this=this;
	  	  	 	setTimeout(function(){
	  	  	 		if(inpValue==_this.searchValue){
	  	  	 			_this.ajaxNum++;
			  	  	 	_this.getdistributorlist();
			  	  	 	_this.searchStatus=true;
			  	  	 	_this.loadingStatus=true;
	  	  	 		}
	  	  	 	},500);	  	 	
	  	  	 }
	  	  },	
	  	  changeDistributor(items){
	  	  	var data={
	  	  		distributorCode:items.distributorCode,
	  	  		agentLoginName:items.selectValue
	  	  	}
	  	  	let _this = this;
	  	  	var _obj={
	  	  		merchantCode:this.userIntro.merchantCode,
	  	  		userLoginName:this.userIntro.userLoginName,
	  	  		password:this.userIntro.password,
	  	  		companyCode:this.userIntro.companyCode,
	  	  		disLoginName:this.userIntro.disLoginName,
	  	  	}
	  	  	localStorage.setItem('businessData',JSON.stringify(_obj));
	  	  	this.isBusiness=true;
	  	  	this.$ajax.post('/distribute/select',data)
			.then(function(response) {
				let res = response.data
				if(res.result == 1) {
					localStorage.setItem('loginCont',JSON.stringify(res.model));
					localStorage.setItem('LOGIN_USER',JSON.stringify(res.model));
					_this.orderName = res.model.companyName;
					_obj.disLogin=res.model.disLoginName;
					_obj.discompanyCode=res.model.companyCode;
					localStorage.setItem('businessData',JSON.stringify(_obj));
					localStorage.setItem('helpCustom',JSON.stringify(_this.orderName));
					var loginData= _this.$store.state;		
					if(loginData) loginData=JSON.parse(JSON.stringify(loginData));
					_this.$store.state.loginNub = loginData.loginNub+1;
		      		_this.isShowB = false;
		      		_this.$router.push({
						path: '/home'
					});
		      }
		    }, function (response) {
		        console.log('数据提交异常');
		    })
	  	  },
	  	  getdistributorHistory(){
	  	  	this.distributorList=[];
	  	  	this.keyWordList=[];
	  	  	let _this = this;
	  	  	this.$ajax.post('/distribute/frequency')
			.then(function(response) {
				let res = response.data
				if(res.result == 1) {
			      	_this.keyWordList=res.model.keyWords;
			      	_this.distributorList=res.model.distList;
			      	if(_this.distributorList){
			      		_this.distributorList.forEach(function(i){
				      		i.agencyList.forEach(function(v){
					      		if(v.selected==true){
					      			i.selectValue=v.agentName;
					      		}
					      	});
				      	});
			      	}

			      }
			    }, function (response) {
			        console.log('数据提交异常');
			    })
	  	  },	
	  	  getdistributorlist(){
	  	  	this.searchDistributorList=[];
	  	  	let _this=this;
	  	  	this.$ajax.post('/distribute/list',{
	  	  		keyword:_this.searchValue,
	  	  	})
			.then(function(response) {
					let res = response.data
					if(res.result == 1) {
			      	_this.requestNum++;
			      	if(_this.requestNum == _this.ajaxNum){
			      		setTimeout(function(){
							_this.loadingStatus=false;
			      		},500);
			      		_this.searchDistributorList=res.model;
				      	_this.searchDistributorList.forEach(function(i){
				      		if(i.agencyList[0]){
				      			i.selectValue=i.agencyList[0].agentName;
				      		}
				      		
				      	});
			      	};
			      	_this.getdistributorHistory();
			      }
			    }, function (response) {
			        console.log('数据提交异常');
			    })
	  	  },
	  	getHasNewMsg() {
	  		var _this = this;
			this.$ajax.post('/message/getHasNewMsg')
				.then(function(response) {
					let res = response.data
					if(res.result == 1) {
						if(res.model){
							_this.$store.state['isNew'] = true;
							_this.isNew = true;
						}else{
							_this.$store.state['isNew'] = false;
							_this.isNew = false;
						}
					}
					// 响应成功回调
				}, function(response) {
					// 响应错误回调
				});
	  	},
		logout() {
			var _this = this;
			this.$ajax.post('/home/logout')
				.then(function(response) {
					let res = response.data
					if(res.result == 1) {
						localStorage.clear();
						_this.isHelp = false;
						_this.$store.state['isLogin'] = 0;
						_this.$router.push({
							path: '/login/loginHome'
						});
					}
					// 响应成功回调
				}, function(response) {
					// 响应错误回调
				});
		},

	},
	watch: {
		getUserInfo(val){
			var userIntro = JSON.parse(localStorage.getItem('loginCont'));
			if(userIntro&&userIntro.fcState&&!this.orderName){
				this.isHelp = true;
				this.isShowB = true;
			}else if(userIntro&&userIntro.fcState&&this.orderName){
				this.isHelp = true;
				this.isShowB = false;
			}else{
				this.isHelp = false;
				this.isShowB = false;
			}
			this.orderName=localStorage.getItem("helpCustom")?JSON.parse(localStorage.getItem("helpCustom")):"";	  
	        this.userIntro=localStorage.getItem("loginCont")?JSON.parse(localStorage.getItem("loginCont")):"";
			var loginData= this.$store.state;		
			if(loginData) loginData=JSON.parse(JSON.stringify(loginData));
			this.merchantName =loginData.loginData&&loginData.loginData.merchantName;
			this.getdistributorHistory();
			if(this.newData==1&&!this.isHelp){
				this.getHasNewMsg()
			}
			if(!this.merchantName) this.getMerchantName();
		},
		'$store.state.isHelp'(val){			
			var userIntro = JSON.parse(localStorage.getItem('loginCont'));
			this.orderName=localStorage.getItem("helpCustom")?JSON.parse(localStorage.getItem("helpCustom")):"";
			if(userIntro&&userIntro.fcState&&!this.orderName){
				this.isHelp = true;
				this.isShowB = true;
			}else if(userIntro&&userIntro.fcState&&this.orderName){
				this.isHelp = true;
				this.isShowB = false;
			}else{
				this.isHelp = false;
				this.isShowB = false;
			}
			this.$store.dispatch('getMerchant');
			var loginData= this.$store.state;		
			if(loginData) loginData=JSON.parse(JSON.stringify(loginData));
			this.merchantName = loginData.loginData.merchantName;
			if(!this.merchantName) this.getMerchantName();
		},
		'$route'(to, from) {	
			if(from.path =='/login/loginHome'&&to.path=='/home'){
				this.isShow = true;
				this.userIntro = JSON.parse(localStorage.getItem("loginCont"));
				if(this.userIntro&&this.userIntro.fcState){
					this.isHelp = true;
					this.isShowB = true;
					this.getdistributorHistory();
				}else{
					this.isHelp = false;
					this.isShowB = false;
				}
				this.createdFn();
			}
			if(to.path == "/login/register" && from.path == "/login/loginHome"){
	    		$('.bg-wrap').css({'width': '480px', 'height':' 700px','transition':'all 0.3s ease'})
		   }else{
	    		if(this.$route.path == '/login/register'){
	    			setTimeout(()=>{
				  		$('.bg-wrap').css({'width': '480px', 'height':' 700px','transition':'all 0.3s ease'})
				  	},100)
	    			
	    		}else{
	    			$('.bg-wrap').css({'width': '450px', 'height':' 500px','transition':'all 0.3s ease'})
	    		}
	    	} 
			var route = this.$route.path.split('/');
			if(route[1] == 'home'|| this.$route.path == '/') {
				this.colorBlack = "#222";
				if(!this.orderName && this.isHelp){
					this.isShowB = true;
					this.getdistributorHistory();
					this.createdFn();
				}
			} else if(route[1] == 'hotellist'){
				this.colorBlack = "#fff";
			}else {
				this.colorBlack = "transparent";
				if(route[1] == 'hotelDetail'){
					$('body').css('background','#fff');
				}else{
					$('body').css('background','#eee');
				}
			}
			if(route[1] == 'registerAgree'|| route[1] == 'groupPrint' || route[1] == 'hotelPrint' || route[1] == 'hotelGetTrip'){
				this.isShow = false;
				$('body').css('overflow-x','auto')
			}else if(route[1] == 'login'){
				this.isShow = false;
				$('body').css('overflow-x','hidden')
			}else{
				this.isShow = true;
				$('body').css('overflow-x','auto')
				if(to.fullPath == "/unpaidBill?id=1"){
					this.$store.state.isbillAll = 1;
				}else{
					this.$store.state.isbillAll = 0;
				}
			}
			if(route[1] == 'dynamicQuotation' || route[1] == 'hotellist' ||route[1] == 'hotelDetail'){
				$('.menu-wrap .menulist>li').eq(1).find('a').addClass(' router-link-exact-active router-link-active');
			}else{
				$('.menu-wrap .menulist>li').eq(1).find('a').removeClass(' router-link-exact-active router-link-active');
			}
		},
	},

}
</script>
<style lang="scss" scope>

@import 'scss/variables';
div {
	.side-bar {
		position: absolute;
	}
	nav {
		background: $complementary;
		color: #fff;
		padding: 10px 0;
		.logo-name{
			width:117px;
			margin:0 20px 0 0px;
			float: left;
			overflow: hidden;
			text-overflow:ellipsis;
			white-space: nowrap;
			
		}
		.clientOrder {
			font-size: 14px;
			float: left;
			.customerName {
				padding-left: 5px;
				max-width: 120px;
				min-width: 30px;
				display: inline-block;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				word-break: break-all;
				vertical-align: text-top;
			}
			.icon-downTriangle {
				padding-right: 5px;
			}
		}
		.clientOrder:hover{
			opacity: 0.5;
			cursor: pointer;
		}
		.menu-wrap{
			width: 1200px;
			margin: 0 auto;
			.poplist:not(.omni-button) .itemlist{
				min-width: 180px;
				>li{
					&.userLoginName{
						cursor: default!important;
						border-bottom: 1px dashed #dee0e5!important;;
						padding: 15px 10px!important;
					}
				}
			}
		}
		.menulist {
			@extend .clear;
			float: right;
			>li {
				position: relative;
				float: left;
				cursor: pointer;
				& .router-link-active {
					opacity: 0.5;
				}
				&:hover .menu-name {
					opacity: 0.5;
				}
				.menu-name {
					padding: 10px 30px;
					.icon-downTriangle {
						font-size: 13px;
					}
				}
				.icon-avatar02:before {
					position: relative;
					font-size: 18px;
					top: 1px;
				}
				.icon-notice:before {
					position: relative;
					font-size: 20px;
					top: 1px;
				}
				&.nav-li{
					>i{
						padding: 0 30px;
					}
					>.poplist{
						padding: 0 30px;
					}
				}
			}
		}
	}
	.page {
		margin-top: 20px;
		padding-bottom: 10px;
	}
}</style>



// WEBPACK FOOTER //
// docs/App.vue